import React from 'react';
import {useI18n} from '../../../../../data/hooks/i18nHooks';
import {useParticipantsListEnabled} from '../../../../../data/hooks/participant/useParticipantsListEnabled';
import StartNetworkingGroup from '../../StartNetworkingGroup/StartNetworkingGroup';
import StepFilterParticipants from './StepFilterParticipants';
import StepFullParticipants from './StepFullParticipants';
import StepRecommendedParticipants from './StepRecommendedParticipants';
import StepSearch from './StepSearch';
import icon from './icon.png';
import styles from './FindGroup.module.scss';

function FindGroup(props) {
    const {eventId} = props,
        i18n = useI18n(),
        participantsEnabled = useParticipantsListEnabled(eventId);

    return (
        <StartNetworkingGroup 
            name={i18n['start.find']} 
            description={i18n['start.find.intro']}
            visible={participantsEnabled}
            icon={icon}
            iconClassName={styles.icon}>
            <StepRecommendedParticipants eventId={eventId} />
            <StepFilterParticipants eventId={eventId} />
            <StepSearch eventId={eventId} />
            <StepFullParticipants eventId={eventId} />
        </StartNetworkingGroup>
    );
}

export default FindGroup;
